// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2OMzV","ranges":"BmiRanges_ranges__2v6Zl"};